import ChangePassword from "../components/mainHeader/userMenu/changePassword/changePassword";

export enum userRoutingAddress {
    changePassword = "/change-password",
}

export const userRoutes = [
    {
        path: userRoutingAddress.changePassword,
        component: ChangePassword
    }
];
